import IconHide from '@assets/icons/hide.svg?react';
import IconShow from '@assets/icons/show.svg?react';
import {
 Box,
 Button,
 FormControl,
 IconButton,
 TextField,
 Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Verify2FA from '@components/login/Verify2FA';
import { AuthenticationTabProps, UserProfileFormData } from './types';
import { UsersDTO } from '../../../redux/identity/identityTypes';
import TwoFactorSection from './TwoFactorSection';

const AuthenticationTab: React.FC<AuthenticationTabProps> = ({
 control,
 errors,
 watch,
 handleSubmit,
 handleFormSubmit,
 self,
 loading,
 twoFactorAuthMethod,
 setTwoFactorAuthMethod,
 verificationCode,
 setVerificationCode,
 handleVerifyTotp,
}) => {
 const { t } = useTranslation();
 //  const [showPassword, setShowPassword] = useState<Record<string, boolean>>({});

 //  const handleTogglePassword = (name: string) =>
 // setShowPassword((prev) => ({ ...prev, [name]: !prev[name] }));

 //  const passwordFields = [
 //   {
 //    name: 'OldPassword' as const,
 //    label: t('user.password.current'),
 //    rules: {
 //     required: t('user.errors.required', {
 //      field: t('user.password.current'),
 //     }),
 //    },
 //   },
 //   {
 //    name: 'NewPassword' as const,
 //    label: t('user.password.new'),
 //    rules: {
 //     required: t('user.errors.required', {
 //      field: t('user.password.new'),
 //     }),
 //     minLength: {
 //      value: 8,
 //      message: t('user.errors.minLength', { min: 8 }),
 //     },
 //    },
 //   },
 //   {
 //    name: 'RepeatPassword' as const,
 //    label: t('user.password.repeat'),
 //    rules: {
 //     required: t('user.errors.repeatPassword'),
 //     validate: (value: string | undefined) =>
 //      value === watch('NewPassword') || t('user.errors.passwordsMatch'),
 //    },
 //   },
 //  ];

 return (
  <form id="password-change-form" onSubmit={handleSubmit(handleFormSubmit)}>
   <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
     <Typography
      sx={{
       fontSize: '14px',
       color: (th) => th.palette.kemek.darkGray,
       fontWeight: 500,
      }}
     >
      {t('user.authentication.title')}
     </Typography>

     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {(['Email', 'Phone'] as const).map((fieldName) => {
       const confirmedKey = (
        fieldName === 'Email' ? 'EmailConfirmed' : 'PhoneConfirmed'
       ) as keyof UsersDTO;
       const isConfirmed = !!(self as UsersDTO)?.[confirmedKey];
       return (
        <Box key={fieldName}>
         <Box sx={{ display: 'flex', gap: '12px' }}>
          <FormControl
           fullWidth
           error={!!(errors as Record<string, UserProfileFormData>)[fieldName]}
          >
           <Controller
            name={fieldName as keyof UserProfileFormData}
            control={control}
            rules={{
             required: t('user.errors.required', {
              field: t(`user.fields.${fieldName}`),
             }),
             pattern:
              fieldName === 'Email'
               ? {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: t('user.errors.invalidEmail'),
                 }
               : {
                  value: /^\+3706\d{7}$/,
                  message: t('user.errors.invalidPhone'),
                 },
            }}
            render={({ field }) => (
             <TextField
              {...field}
              id={fieldName}
              type={fieldName === 'Email' ? 'email' : 'tel'}
              label={t(`user.fields.${fieldName.toLowerCase()}`)}
              variant="outlined"
              error={
               !!(errors as Record<string, UserProfileFormData>)[fieldName]
              }
              helperText={
               (errors as Record<string, { message?: string }>)[fieldName]
                ?.message
              }
             />
            )}
           />
          </FormControl>
          {!isConfirmed && (
           <Button
            variant="outlined"
            size="medium"
            sx={{ minHeight: 44 }}
            onClick={() => {
             setTwoFactorAuthMethod(fieldName === 'Email' ? 1 : 2);
            }}
            disabled={isConfirmed}
           >
            {t('user.buttons.confirm')}
           </Button>
          )}
         </Box>
         {twoFactorAuthMethod === (fieldName === 'Email' ? 1 : 2) && (
          <Verify2FA
           verificationCode={verificationCode}
           onVerificationCodeChange={setVerificationCode}
           onVerifyTotp={handleVerifyTotp}
           loading={loading}
           method={twoFactorAuthMethod}
           control={control}
           setTwoFactorAuthMethod={setTwoFactorAuthMethod}
          />
         )}
        </Box>
       );
      })}
     </Box>
    </Box>

    <TwoFactorSection />

    {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
     <Typography
      sx={{
       fontSize: '14px',
       color: (th) => th.palette.kemek.darkGray,
       fontWeight: 500,
      }}
     >
      {t('user.password.changeTitle')}
     </Typography>

     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {passwordFields.map(({ name, label, rules }) => (
       <FormControl key={name} fullWidth error={!!errors[name]}>
        <Controller
         name={name}
         control={control}
         rules={rules}
         render={({ field }) => (
          <Box sx={{ position: 'relative' }}>
           <TextField
            {...field}
            id={name}
            type={showPassword[name] ? 'text' : 'password'}
            label={label}
            variant="outlined"
            error={!!errors[name]}
            helperText={errors[name]?.message}
            fullWidth
           />
           <IconButton
            onClick={() => handleTogglePassword(name)}
            aria-label={
             showPassword[name] ? 'hide password' : 'show password'
            }
            sx={{
             position: 'absolute',
             top: '21px',
             right: '12px',
             transform: 'translateY(-50%)',
             opacity: 0.5,
             color: (th) => th.palette.kemek.darkGray,
            }}
           >
            {showPassword[name] ? <IconHide /> : <IconShow />}
           </IconButton>
          </Box>
         )}
        />
       </FormControl>
      ))}
     </Box>
    </Box> */}
   </Box>
  </form>
 );
};

export default AuthenticationTab;

